( () => {
    var e = {
        188: () => {
            document.addEventListener("DOMContentLoaded", ( () => {
                let e = document.querySelectorAll(".faq_block__block");
                e.forEach((t => {
                    let o = t.querySelector(".faq_block__block-title")
                      , r = t.querySelector(".faq_block__block-text");
                    o.addEventListener("click", ( () => {
                        let o = t.classList.contains("open");
                        e.forEach((e => {
                            e.classList.remove("open"),
                            e.querySelector(".faq_block__block-text").style.display = "none"
                        }
                        )),
                        t.classList.toggle("open", !o),
                        r.style.display = o ? "none" : "block"
                    }
                    ))
                }
                ))
            }
            ))
        }
        ,
        5460: () => {
            document.addEventListener("DOMContentLoaded", (function() {
                if (document.querySelector(".product-benefits")) {
                    new Swiper(".product-benefits",{
                        spaceBetween: 10,
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                        watchOverflow: true,
                          pagination: {
                            clickable: !0,
                            el: ".product-benefits-pagination"
                        },
                        breakpoints: {
                            768: {
                                slidesPerView: 4,
                                slidesPerGroup: 4
                            },
                            1024: {
                                slidesPerView: 5,
                                slidesPerGroup: 5
                            },
                            1280: {
                                slidesPerView: 7,
                                slidesPerGroup: 7
                            }
                        }
                    })
                }
            }
            ))
        }
    }
      , t = {};
    function o(r) {
        var n = t[r];
        if (void 0 !== n)
            return n.exports;
        var l = t[r] = {
            exports: {}
        };
        return e[r](l, l.exports, o),
        l.exports
    }
    o.n = e => {
        var t = e && e.__esModule ? () => e.default : () => e;
        return o.d(t, {
            a: t
        }),
        t
    }
    ,
    o.d = (e, t) => {
        for (var r in t)
            o.o(t, r) && !o.o(e, r) && Object.defineProperty(e, r, {
                enumerable: !0,
                get: t[r]
            })
    }
    ,
    o.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t),
    ( () => {
        "use strict";
        o(5460),
        o(188)
    }
    )()
}
)();
